import React, { useState, useEffect, useMemo } from 'react';
import { generateUnits } from './units';

export const InputField = ({ input, onChange }) => {
  const { id, label, inputType, value, baseUnit, disabled } = input;

  const units = useMemo(() => generateUnits(baseUnit), [baseUnit]);

  const [selectedUnit, setSelectedUnit] = useState(() => getAppropriateUnit(value, units));
  const [inputValue, setInputValue] = useState(() => roundTo9Decimals(convertToUnit(value, selectedUnit)));

  useEffect(() => {
    const newSelectedUnit = getAppropriateUnit(value, units);
    setSelectedUnit(newSelectedUnit);
    setInputValue(roundTo9Decimals(convertToUnit(value, newSelectedUnit)));
  }, [value, units]);

  const handleValueChange = (e) => {
    const newValueInSelectedUnit = parseFloat(e.target.value);
    const roundedValue = roundTo9Decimals(newValueInSelectedUnit);
    setInputValue(roundedValue);
    onChange(id, roundedValue * selectedUnit.factor);
  };

  const handleUnitChange = (e) => {
    const newUnit = units.find(u => u.symbol === e.target.value);
    const valueInBaseUnit = inputValue * selectedUnit.factor;
    setSelectedUnit(newUnit);
    setInputValue(roundTo9Decimals(valueInBaseUnit / newUnit.factor));
  };

  const handleResetUnit = () => {
    const valueInBaseUnit = inputValue * selectedUnit.factor;
    const newSelectedUnit = getAppropriateUnit(valueInBaseUnit, units);
    setSelectedUnit(newSelectedUnit);
    setInputValue(roundTo9Decimals(convertToUnit(valueInBaseUnit, newSelectedUnit)));
  };

  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <input
        disabled={disabled}
        id={id}
        type={inputType}
        value={inputValue.toString()}
        onChange={handleValueChange}
      />
      <select value={selectedUnit.symbol} onChange={handleUnitChange}>
        {units.map(u => (
          <option key={u.symbol} value={u.symbol}>{u.symbol}</option>
        ))}
      </select>
      <button type="button" onClick={handleResetUnit}>Reset Unit</button>
    </div>
  );
};

function getAppropriateUnit(valueInBaseUnit, units) {
  const absValue = Math.abs(valueInBaseUnit);
  for (let i = units.length - 1; i >= 0; i--) {
    const unit = units[i];
    const convertedValue = absValue / unit.factor;
    if (convertedValue >= 1 && convertedValue < 1000) {
      return unit;
    }
  }
  return units[0]; // Default to the smallest unit
}

function convertToUnit(valueInBaseUnit, unit) {
  return valueInBaseUnit / unit.factor;
}

function roundTo9Decimals(num) {
  return Math.round(num * 1000000000) / 1000000000;
}
